export enum VoucherDiscountType {
  Percentage = 1,
  Fixed = 2,
  FreeDelivery = 3,
}

export interface IVoucher {
  voucherId: number;
  voucherCode: string; // changed to string – codes are often alphanumeric
  minOrderValue: number;
  startDate: string; // ISO format (e.g. "2025-11-12T00:00:00Z")
  endDate: string;
  productIds?: number[]; // optional if voucher applies to multiple/all products
  maxUsesTotal?: number;
  maxUsesPerUser?: number;
  discountType: VoucherDiscountType;
  discountValue: number; // unified field for amount or percentage
}

export interface IShareVoucherRequest {
  voucherId: number;
  email: boolean;
  sms: boolean;
  whatsApp: boolean;
}
